import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import AddResponseParameter from './AddResponseParameter';

const ResponseParametersForm = ({ responseParameters, setResponseParameters, formData, setFormData }) => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [editingParameter, setEditingParameter] = useState(null);

    const handleAddResponseParam = () => {
        setShowAddModal(true);
    };

    const handleEditResponseParam = (param) => {
        setEditingParameter(param);
        setShowAddModal(true);
    };

    const handleDeleteResponseParam = (paramId) => {
        const newList = responseParameters.filter((p) => p.id !== paramId);
        setResponseParameters(newList);
        setFormData((prev) => ({ ...prev, responseParameters: newList }));
    };

    const handleModalClose = () => {
        setShowAddModal(false);
        setEditingParameter(null);
    };

    const handleModalSuccess = (parameter) => {
        let newList;
        if (editingParameter) {
            // Update existing parameter
            newList = responseParameters.map(p => 
                p.id === parameter.id ? parameter : p
            );
        } else {
            // Add new parameter
            newList = [...responseParameters, parameter];
        }
        
        setResponseParameters(newList);
        setFormData((prev) => ({ ...prev, responseParameters: newList }));
        handleModalClose();
    };

    return (
        <Form.Group className="mt-4">
            <Form.Label>
                <b>Response Parameters</b>
            </Form.Label>
            <br />

            <Button variant="primary" onClick={handleAddResponseParam} className="mb-3">
                Add Response Parameter
            </Button>

            {responseParameters.length === 0 && (
                <div style={{ fontStyle: 'italic', color: '#999' }}>No response parameters added</div>
            )}

            {responseParameters.length > 0 && (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {responseParameters.map((param) => (
                                <tr key={param.id}>
                                    <td>{param.name}</td>
                                    <td>{param.type}</td>
                                    <td>
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            className="me-2"
                                            onClick={() => handleEditResponseParam(param)}
                                        >
                                            <i className="fa fa-pencil"></i>
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => handleDeleteResponseParam(param.id)}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <AddResponseParameter
                isOpen={showAddModal}
                row={editingParameter}
                onSuccessCallBack={handleModalSuccess}
                onClose={handleModalClose}
            />
        </Form.Group>
    );
};

export default ResponseParametersForm; 